import React, { useEffect, useState } from 'react';
import { Navbar } from 'react-bootstrap';
import { Orders } from '../../../common/interfaces';

// Función auxiliar para formatear cantidades
const formatQuantity = (quantity: number): string => {
  return Number.isInteger(quantity) ? quantity.toString() : quantity.toFixed(2);
};

// Función para formatear cantidades con unidades, convirtiendo kg a g cuando es menor a 1
const formatQuantityWithUnit = (quantity: number, unit: string = ''): { value: string, unit: string } => {
  // Si la unidad es Kg y el valor es menor a 1, convertir a gramos
  if (unit === 'Kg' && quantity < 1) {
    const grams = Math.round(quantity * 1000);
    return { value: grams.toString(), unit: 'g' };
  }

  // Para otros casos, usar el formateo normal
  return { value: formatQuantity(quantity), unit };
};

interface KitchenBannerProps {
  orders: Orders[];
  totalOrders: number;
}

const KitchenBanner: React.FC<KitchenBannerProps> = ({ orders, totalOrders }) => {
  const [productCounts, setProductCounts] = useState<Record<string, { count: number, unit: string }>>({});
  const [totalCookingOrders, setTotalCookingOrders] = useState<number>(0); // Estado para los pedidos en "Cooking"


  useEffect(() => {
    const counts: Record<string, { count: number, unit: string }> = {};
    let cookingOrders = 0;

    console.log("KitchenBanner - Órdenes recibidas:", orders);

    orders.forEach(order => {
      const kitchenStatus = order.kitchen_status || order.status;
      console.log("Procesando orden:", order.id, "Kitchen Status:", kitchenStatus);

      if (kitchenStatus == 'Cooking') {
        order.detalles.forEach(detalle => {
          console.log("Detalle:", detalle.id, "Producto:", detalle.producto.name);
          console.log("¿Tiene assembled_products?", !!detalle.producto.assembled_products);

          const ensamble = detalle.producto.assembled_products;

          if (ensamble && ensamble.length > 0) {
            console.log("Cantidad de productos ensamblados:", ensamble.length);

            ensamble.forEach(product => {
              console.log("Producto ensamblado:", product.name, "is_banner:", product.is_banner);

              // Verificar si el producto debe mostrarse en el banner (is_banner === 1)
              // O si no existe is_banner, mostrar todos los productos (compatibilidad con versiones anteriores)
              if (product.is_banner === 1) {
                const qty = parseFloat(product.pivot.quantity);
                const unit = product.unit || '';

                console.log("Agregando al banner:", product.name, "Cantidad:", qty, "Unidad:", unit);

                if (counts[product.name]) {
                  counts[product.name].count += qty;
                } else {
                  counts[product.name] = { count: qty, unit };
                }
              }
            });
          }
        });

        cookingOrders++;
      }
    });

    console.log("Conteo final de productos:", counts);
    setProductCounts(counts); // Actualiza el estado
    setTotalCookingOrders(cookingOrders);
  }, [orders]); // Recalcula cuando cambian las órdenes

  return (
    <Navbar sticky="top" bg="dark" variant="dark" className="flex-column align-items-start" style={{ marginTop: '0px', marginBottom: '10px', top: '60px' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'left', alignItems: 'flex-start', color: 'white', fontSize: '18px' }}>
        <div className="item-kitchen-banner">
          <Navbar.Text style={{ color: 'white', fontSize: '18px', marginLeft: '10px' }}>
            PEDIDOS: <strong style={{ fontSize: '25px' }}>{totalOrders}</strong>
          </Navbar.Text>
          <Navbar.Text style={{ color: 'white', fontSize: '18px', marginLeft: '10px' }}>
            COCINANDO: <strong style={{ fontSize: '25px' }}>{totalCookingOrders}</strong>
          </Navbar.Text>
        </div>

        {Object.entries(productCounts).map(([productName, data]) => (
          <div key={productName} style={{ display: 'flex', flexDirection: 'column', marginLeft:'5px', marginBottom: '10px' }} className="item-kitchen-banner">
            <div style={{ wordWrap: 'break-word', hyphens: 'auto' }}>
              {productName.toUpperCase().replace('ASADERO', '').trim()}:
            </div>
            <div style={{
              fontSize: '25px',
              fontWeight: 'bold',
              display: 'flex',
              justifyContent: 'flex-start'
            }}>
              {(() => {
                const formatted = formatQuantityWithUnit(data.count, data.unit);
                return `${formatted.value} ${formatted.unit}`;
              })()}
            </div>
          </div>
        ))}
      </div>
    </Navbar>
  );
};

export default KitchenBanner;
